/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./";

/**
 *
 * @export
 * @interface StringIEnumerableControllerResponse
 */
export interface StringIEnumerableControllerResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof StringIEnumerableControllerResponse
   */
  data?: Array<string> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof StringIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function StringIEnumerableControllerResponseFromJSON(json: any): StringIEnumerableControllerResponse {
  return StringIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function StringIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StringIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : json["data"],
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function StringIEnumerableControllerResponseToJSON(value?: StringIEnumerableControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: value.data,
    error: ErrorResponseToJSON(value.error),
  };
}
